module.exports = __webpack_public_path__ + "img/step43_a_printer_power_route_cables.ed0cc03b.png";